import React, {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {PageHeader} from "../components/layout/PageHeader";
import {useHistory} from "react-router-dom";
import {Spin} from "antd";
import {Eye} from "react-feather";
import {getCertificatesChain, useCertificatesChain} from "../hooks/certificate";
import {CertificateTreeItemDto} from "../generated-api";
import {BackButton} from "../components/layout/BackButton";

export function CertificateMapPage({match}: any) {
    const {certificateId} = (match || {}).params || {};
    const {t} = useTranslation();
    const history = useHistory();
    useEffect(() => {
        if (certificateId) {
            getCertificatesChain(certificateId, true).then().catch(error => {
                console.error(error);
                history.push('/certificates');
            });
        }
    }, [certificateId]);
    const certificatesChainResponse = useCertificatesChain();
    const {parentCertificates, childCertificates, hash} = certificatesChainResponse.data || {};

    return (
        <Spin spinning={certificatesChainResponse.loading}>
            <PageHeader/>
            <div className={'top-block accent4-background'}>
                <div className={'flex-row'}>
                    <h1 className={'h1 flex-auto'}><BackButton backPath={'/certificates'}/>{t('certificate.mapTitle')}</h1>
                    <a href={'/certificates/' + certificateId} className={'title-icon-button'}
                       onClick={event => {
                           event.preventDefault();
                           history.push('/certificates/' + certificateId);
                       }}>
                        <Eye/>
                        <div className={'title-icon-button-text'}>{t('certificate.label')}</div>
                    </a>
                </div>
            </div>
            <div className={'subpage-content'}>
                <ul className={'map-list' + (!(parentCertificates || []).length ? ' no-parents' : '')}>
                    {(parentCertificates || []).map((item: CertificateTreeItemDto, index: number) =>
                        <li key={index} className={'level-1'}>
                            <a href={'/certificates/' + item.certificateId + '/map'} onClick={event => {
                                event.preventDefault();
                                history.push('/certificates/' + item.certificateId + '/map');
                            }}>{item.hash}</a>
                        </li>
                    )}
                    <li className={'level-2'}>{hash}</li>
                    {(childCertificates || []).map((item: CertificateTreeItemDto, index: number) =>
                        <li key={index} className={'level-3'}>
                            <a href={'/certificates/' + item.certificateId + '/map'} onClick={event => {
                                event.preventDefault();
                                history.push('/certificates/' + item.certificateId + '/map');
                            }}>{item.hash}</a>
                        </li>
                    )}
                </ul>
            </div>
        </Spin>
    )
}
